<script setup lang="ts">
import { computed } from 'vue';
import SeasonalSelectDate from './SeasonalSelectDate.vue';
import SeasonalSelectDayOfWeek from './SeasonalSelectDayOfWeek.vue';
import SeasonalDuration from './SeasonalDuration.vue';

interface Props {
  title: string;
  seasonalData: any;
  validateSeason: string | undefined;
  seasonalDefault: any;
  isSeasonalException?: boolean;
}
const props = defineProps<Props>();

const emits = defineEmits<{ 'update:seasonalData': [value: any] }>();

const seasonal = computed({
  get() {
    return props.seasonalData;
  },
  set(value) {
    emits('update:seasonalData', value);
  }
});
</script>
<template>
  <div class="w-full seasonal-flight-rule-cntnr">
    <p class="mb-1 uppercase text-lg font-bold">{{ title }}</p>
    <div class="mt-2">
      <SeasonalSelectDate
        v-model:isDefaultSeason="seasonal.isDefaultSeason"
        v-model:startDay="seasonal.startDay"
        v-model:startMonth="seasonal.startMonth"
        v-model:endDay="seasonal.endDay"
        v-model:endMonth="seasonal.endMonth"
        :seasonalDefault="seasonalDefault"
        :isSeasonalException="isSeasonalException"
      />
      <div class="mt-4">
        <SeasonalSelectDayOfWeek v-model:listDayOfWeek="seasonal.dayOfWeeks" />
      </div>
      <div class="mt-4">
        <SeasonalDuration v-model:durations="seasonal.durations" :validateSeason="validateSeason" />
      </div>
    </div>
  </div>
</template>
